import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, catchError } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageRefService } from './local-storage-ref.service';
import { UtilsService } from './utils.service';

interface Product {
  inventoryGuId: string,
  userGuidId: string,
  maxQuantity: number,
  productName: string,
  productMRP: number,
  productMSP: number,
  sellingPrice: number,
  taxPercent: number,
  pincode: number,
  productImageFileName: string,
  productInventoryCount: number,
  quantity: number,
  deliverySLA: string
}

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private _localStorage!: Storage;
  public cartData$ = new BehaviorSubject<Product[] | null>(null)
  public buyNowData$ = new BehaviorSubject<Product[] | null>(null)
  // public cartData$ = this._cartData$.asObservable()

  constructor(public http: HttpClient, public utils: UtilsService, @Inject(PLATFORM_ID) private platformId: Object, private _localStorageRefService: LocalStorageRefService) {
    if (isPlatformBrowser(this.platformId)) {
    this._localStorage = _localStorageRefService.localStorage
  }
}

  getItems() {
    let url = `${this.utils.apiUrl}Cart/GetCartDetails`
    return this.http.get(url)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

setInfo(data: any, isBuyNow: boolean) {
    if (isPlatformBrowser(this.platformId)) {
        let encryptedData: any | null;

        if (data === null) {
            encryptedData = null;
        } else {
            let jsonData: string | null = null; // Initialize jsonData
            // Check if data is already encrypted (assuming encrypted data is a string that can't be parsed as JSON)
            if (typeof data === 'string') {
                try {
                    JSON.parse(data);
                    jsonData = data; // Data is a JSON string but not encrypted
                } catch (e) {
                    encryptedData = data; // Assume data is already encrypted
                }
            } else {
                jsonData = JSON.stringify(data); // Convert to JSON string
            }

            // Encrypt only if data is not already encrypted
            if (!encryptedData && jsonData !== null) {
                encryptedData = this.utils.encryptarrayData(jsonData); // Encrypt the JSON string
            }
        }

        if (isBuyNow) {
            this._localStorage.setItem('buyNow', encryptedData);
            this.buyNowData$.next(null);
            this.buyNowData$.next(data);
        } else {
            this._localStorage.setItem('cart', encryptedData);
            this.cartData$.next(null);
            this.cartData$.next(data);
        }
    } 
}

loadInfo() {
  if (isPlatformBrowser(this.platformId)) {
    try {
      // Handle cart data
      const encryptedCart = this._localStorage.getItem('cart');
      if (encryptedCart) {
        const decryptedCart = this.utils.decryptarrayText(encryptedCart);
        if (decryptedCart && decryptedCart != null && decryptedCart != "null") {
          const cartData = JSON.parse(decryptedCart) ;
          this.cartData$.next(cartData);
        } else {
          this.cartData$.next(null);
        }
      } else {
        this.cartData$.next(null);
      }

      // Handle buyNow data
      const encryptedBuyNow = this._localStorage.getItem('buyNow');
      if (encryptedBuyNow) {
        const decryptedBuyNow = this.utils.decryptarrayText(encryptedBuyNow);
        if (decryptedBuyNow && decryptedBuyNow != null && decryptedBuyNow != "null") {
          const buyNowData = JSON.parse(decryptedBuyNow) ;
          this.buyNowData$.next(buyNowData);
        } else {
          this.buyNowData$.next(null);
        }
      } else {
        this.buyNowData$.next(null);
      }
    } catch (error) {
      console.error('Error processing cart or buyNow data:', error);
      this.cartData$.next(null);
      this.buyNowData$.next(null);
    }
  }
}

  clearInfo() {
    if (isPlatformBrowser(this.platformId)) {
    this._localStorage.removeItem('cart')
    this._localStorage.removeItem('buyNow')
    this.cartData$.next(null)
  }
}

  clearBuynow() {
    if (isPlatformBrowser(this.platformId)) {
    this._localStorage.removeItem('buyNow')
    this.buyNowData$.next(null)
  }
}

  processCartItems(cartInfo$: any, response: any, updateCart: any, emptyCart: any, isPincodeChangeMethod: boolean, isLoginPage: boolean, isPincodeDifferent?: any) {
    if (isPlatformBrowser(this.platformId)) {
    this.utils.isRecentLogin = false;
      const encryptedbuyNow: any = this._localStorage.getItem('buyNow');
      const decryptedbuyNow = this.utils.decryptarrayText(encryptedbuyNow);
    let buyNow = decryptedbuyNow;

    if (response.cartDetailList && response.cartDetailList.length) {
      let indexToRemoveFromCart = [];
      let productToAdd: any = []
      let isCartUpdated = false;
      let isPincodeDiffers = false;

      //iterating local cart object
      for (let [ind, element] of cartInfo$.entries()) {
        //checking the response have the same product or not
        const index = response.cartDetailList.findIndex((prod: any) => { return prod.productGuId == element.productGuId })

        //reponse having the same product
        if (index != -1) {
          if (response.cartDetailList[index].productInventoryCount == 0) {
            //if reponse product doesnt have the product inventory count so remove it from local cart
            indexToRemoveFromCart.push(ind);
            isCartUpdated = true;
          }
          else {
            if (!response.cartDetailList[index].quantity) {
              response.cartDetailList[index].quantity = cartInfo$[ind].quantity;
            }
            if (((cartInfo$[ind].quantity == response.cartDetailList[index].quantity) || (cartInfo$[ind].quantity < response.cartDetailList[index].quantity) || (cartInfo$[ind].quantity > response.cartDetailList[index].quantity)) && isLoginPage) {
              cartInfo$[ind].quantity = cartInfo$[ind].quantity + response.cartDetailList[index].quantity;
              isCartUpdated = true;
            }
            if ((cartInfo$[ind].quantity > response.cartDetailList[index].quantity) && !isPincodeChangeMethod) {
              // cartInfo$[ind].quantity = response.cartDetailList[index].quantity;
              isCartUpdated = true;
            }
            if ((cartInfo$[ind].quantity < response.cartDetailList[index].quantity) || (cartInfo$[ind].quantity > response.cartDetailList[index].quantity) && isPincodeChangeMethod) {
              cartInfo$[ind].quantity = response.cartDetailList[index].quantity;
              isCartUpdated = true;
            }
            if (cartInfo$[ind].quantity && response.cartDetailList[index].productInventoryCount && (cartInfo$[ind].quantity > response.cartDetailList[index].productInventoryCount)) {
              cartInfo$[ind].quantity = response.cartDetailList[index].productInventoryCount;
              isCartUpdated = true;
            }
            cartInfo$[ind].inventory = response.cartDetailList[index].productInventoryCount;
            cartInfo$[ind].inventoryGuId = response.cartDetailList[index].inventoryGuId;
            cartInfo$[ind].userGuidId = this.utils.getUserGuid();
            if (cartInfo$[ind].quantity > response.cartDetailList[index].maxQuantity) {
              cartInfo$[ind].quantity = response.cartDetailList[index].maxQuantity;
              isCartUpdated = true;
            }
            cartInfo$[ind].maxQuantity = response.cartDetailList[index].maxQuantity;
            cartInfo$[ind].productName = response.cartDetailList[index].productName;
            if (cartInfo$[ind].sellingPrice != (isPincodeChangeMethod ? (response.cartDetailList[index].sellingPrice + response.cartDetailList[index].discount) : response.cartDetailList[index].sellingPrice)) {
              cartInfo$[ind].sellingPrice = (isPincodeChangeMethod ? (response.cartDetailList[index].sellingPrice + response.cartDetailList[index].discount) : response.cartDetailList[index].sellingPrice);
              isCartUpdated = true;
            }
            cartInfo$[ind].productMRP = response.cartDetailList[index].productMRP;
            cartInfo$[ind].productMSP = response.cartDetailList[index].productMSP;

            // comment this if required
            cartInfo$[ind].taxPercent = response.cartDetailList[index].taxPercent;
            // if (cartInfo$[ind].taxPercent != response.cartDetailList[index].taxPercent || !cartInfo$[ind].taxPercent) {
            //   cartInfo$[ind].taxPercent = response.cartDetailList[index].taxPercent ? response.cartDetailList[index].taxPercent:0;
            //   isCartUpdated = true;
            // }
            if (!this.utils.getUserPicode()) {
              this.utils.setUserPicode(response.cartDetailList[index].pincode);
            }
            else {
              if (this.utils.getUserPicode() != response.cartDetailList[index].pincode) {
                isPincodeDiffers = true;
                isCartUpdated = true;
              }
            }
            cartInfo$[ind].pincode = response.cartDetailList[index].pincode;
            cartInfo$[ind].productImageFileName = response.cartDetailList[index].productImageFileName;
            cartInfo$[ind].productInventoryCount = response.cartDetailList[index].productInventoryCount;
            cartInfo$[ind].deliverySLA = response.cartDetailList[index].deliverySLA;
            cartInfo$[ind].discount = response.cartDetailList[index].discount;
            cartInfo$[ind].productGuId = response.cartDetailList[index].productGuId;
            cartInfo$[ind].distributorGuid = response.cartDetailList[index].distributorGuid;
            cartInfo$[ind].finalAmount =  cartInfo$[ind].finalAmount;
            if (buyNow) {
              this.setInfo(cartInfo$, true)
            }
            else
              this.setInfo(cartInfo$, false)
          }
        }
        else {
          //checking if the call is coming from pincode change function
          if (isPincodeChangeMethod)
            //if yes the adding it to remove that product from cart
            indexToRemoveFromCart.push(ind);
          // else {
          // //if no then added that product
          //   let proIndex = productToAdd.findIndex((prod: any) => prod.productGuId == element.productGuId)
          //   if (proIndex == -1)
          //     productToAdd.push(element);
          // }
        }
      };
      productToAdd = [];
      for (let ele of response.cartDetailList) {
        const index = cartInfo$.findIndex((prod: any) => prod.productGuId == ele.productGuId)
        if (index == -1) {
          productToAdd.push(ele);
        }
      }
      if (indexToRemoveFromCart && indexToRemoveFromCart.length) {
        indexToRemoveFromCart = indexToRemoveFromCart.sort(function (a: any, b: any) { return b - a });
        indexToRemoveFromCart.forEach((element: any) => {
          cartInfo$.splice(element, 1);
        });
          window.scrollTo(0, 0)

        if (buyNow) {
          this.setInfo(cartInfo$, true)
        }
        else
          this.setInfo(cartInfo$, false)
        isCartUpdated = true;
      }
      if (productToAdd && productToAdd.length) {
        if (buyNow) {
          this.setInfo([...cartInfo$, ...productToAdd], true)
        }
        else
          this.setInfo([...cartInfo$, ...productToAdd], false)
        isCartUpdated = true;
      }
      if (isPincodeDiffers) {
        isPincodeDifferent(true);
      }
      else if (isCartUpdated) {
        this.utils.openCartChangeDialog(() => { });
        updateCart(true);
      }
      // else if (isPincodeDiffers && !isPincodeChangeMethod) {
      //   isPincodeDifferent(true);
      // }
      // else if()
      this.utils.hideLoading();
    }

    //response doesnot have any entry but local have and this call is not coming from the pincode change function => we have to update the cart by local cart
    else if (!isPincodeChangeMethod) {
      if (buyNow) {
        this.setInfo(cartInfo$, true)
      }
      else
        this.setInfo(cartInfo$, false)
      updateCart(true);
    }

    //response empty and this call is coming from pincode change function
    else {
      emptyCart(true);
      this.utils.hideLoading();
    }
  }
}
}
